import { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { initializeMarketStatistics, liveMatchMarketStats$$, prematchMarketStats$$ } from '../reframe/h&s';
import { ticketusActiveMark$ } from '../../turboLive/components/tickets/subs';

const useMatchMarketStats = (matchId: string, live: boolean) => {
    const { derefSub } = useReframe();
    const matchStats = live ? derefSub(liveMatchMarketStats$$(matchId)) : derefSub(prematchMarketStats$$(matchId));
    const mark = derefSub(ticketusActiveMark$);
    useEffect(() => {
        if (!matchStats?.size) {
            dispatch(initializeMarketStatistics(matchId, live ? 'Live' : 'Prematch'));
        }
    }, [matchStats, matchId, live, mark]);
    return matchStats?.size;
};

export default useMatchMarketStats;
